import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from 'src/app/features/spc/process-charts/services/helper.service';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'app-ega-shift-date-selector',
    templateUrl: './ega-shift-date-selector.component.html',
    styleUrls: ['./ega-shift-date-selector.component.scss'],
    standalone: false
})
export class EgaShiftDateSelectorComponent implements OnInit, OnChanges {
  @Input() disabledDates: { min: boolean, max: boolean };
  @Input() allDates: any = {};
  @Input() mode = 'create';
  @Output() applyDate = new EventEmitter<any>();
  public customDate: any;
  public selectionCorrect = true;
  public today = new Date();
  public isStartDisable = false;
  public isEndDisable = false;
  sKeys: any = {};

  constructor(public utilSer: UtilsService, private datePipe: DatePipe,
    private router: Router,
    public helperService: HelperService) {
    this.today.setHours(0);
    this.today.setMinutes(0);
    this.today.setSeconds(0);
    this.today.setMilliseconds(0);

    const urlSplit = this.router.url.split('/');
    const source: string = urlSplit[urlSplit.length - 1];
    this.sKeys = this.helperService.sessionKeys[source];
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.isStartDisable = this.disabledDates.min;
    this.isEndDisable = this.disabledDates.max;
    if (this.allDates.startDate && this.allDates.endDate) {
      this.customDate = {
        from: this.allDates.startDate,
        to: this.allDates.endDate
      };
    } else {
      this.customDate = {
        from: this.allDates.startDate ? this.allDates.startDate : this.today,
        to: this.allDates.endDate ? this.allDates.endDate : this.today
      };
    }

    if (this.mode === 'edit') {
      this.isStartDisable = !this.allDates.startDate || this.allDates.startDate < this.today ? true : this.isStartDisable;
      this.isEndDisable = !this.allDates.endDate || this.allDates.endDate < this.today ? true : this.isEndDisable;
    }

    this.customDateChange();
  }

  public ngOnInit(): void {
    this.customDate = {
      from: new Date(),
      to: new Date()
    };
    if (this.allDates.startDate) {
      this.customDate = {
        from: this.allDates.startDate,
        to: this.today
      };
    }
    if (this.allDates.endDate) {
      this.customDate = {
        from: this.allDates.startDate ? this.allDates.startDate : this.today,
        to: this.allDates.endDate
      };
    }
    this.customDateChange();
  }

  public customDateChange(): void {
    const fd = new Date(this.customDate.from);
    if (this.customDate.from && this.customDate.to && (+this.customDate.from <= +this.customDate.to)) {
      this.selectionCorrect = true;
    } else {
      this.selectionCorrect = false;
      const td = new Date(this.customDate.to);
      if (fd.getDate() === td.getDate() &&
        fd.getMonth() === td.getMonth() &&
        fd.getFullYear() === td.getFullYear()) {
        this.selectionCorrect = true;
      }
    }
    if (this.customDate.from < this.today && this.customDate.to < this.today) {
      this.selectionCorrect = false;
    }
    if (!this.allDates.endDate && this.mode === 'edit') {
      const d = new Date();
      d.setUTCHours(0, 0, 0, 0);
      const futureDate = d.setDate(d.getDate() + 1);
      if (!this.allDates.startDate) {
        this.isStartDisable = false;
        this.isEndDisable = false;
      } else if (this.allDates.startDate < this.today) {
        this.selectionCorrect = false;
      } else if (fd.getDate() === this.today.getDate() &&
        fd.getMonth() === this.today.getMonth() &&
        fd.getFullYear() === this.today.getFullYear()) {
        this.isStartDisable = true;
        this.isEndDisable = false;
        this.selectionCorrect = true;
      } else if (this.allDates.startDate > futureDate) {
        this.isStartDisable = false;
        this.isEndDisable = false;
        this.selectionCorrect = true;
      }
    }
  }

  public applyCustomDate() {
    // meit converted date (to factory local time)
    const selectedFrom = new Date(this.customDate.from.setHours(0, 0, 0));
    const selectedTo = new Date(this.customDate.to.setHours(23, 59, 59));
    const converteddate: any = {
      from: selectedFrom,
      to: selectedTo,
      date: this.datePipe.transform(selectedFrom, 'MMM d, y') + ' - ' + this.datePipe.transform(selectedTo, 'MMM d, y')
    };
    this.applyDate.emit(converteddate);
  }

}
